export default "__VITE_ASSET__Zs5PLdLp__"